export const LOGIN = 'LOGIN'
export const AUTO_LOGIN = 'AUTO_LOGIN'
export const SOCIAL_LOGIN_OAUTH2 = 'SOCIAL_LOGIN_OAUTH2'
export const SOCIAL_LOGIN_OAUTH1_STEP1 = 'SOCIAL_LOGIN_OAUTH1_STEP1'
export const SOCIAL_LOGIN_OAUTH1_STEP2 = 'SOCIAL_LOGIN_OAUTH1_STEP2'
export const SOCIAL_LOGIN_OAUTH1_STEP1_SUCCESS = 'SOCIAL_LOGIN_OAUTH1_STEP1_SUCCESS'
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS'
export const LOGIN_FAILURE = 'LOGIN_FAILURE'
export const LOGOUT = 'LOGOUT'
